import { useEffect, useState } from 'react';
import { Trophy, Flame } from 'lucide-react';
import './trophies.css';

export const TrophyStatus = ({ trophy, score, identity, prefix }) => {
  const [celebrate,setCelebrate]=useState(false);
  useEffect(()=>{
    if(!trophy)return;
    const key=`necs-trophy-seen:${identity}`;
    try { const last=Number(localStorage.getItem(key)||0);setCelebrate(trophy.revision>last);localStorage.setItem(key,String(trophy.revision)); } catch {}
  },[identity,trophy?.revision]);
  if(!trophy)return null;
  return <div className={`flex flex-wrap items-center gap-4 border-y py-5 ${celebrate?'necs-trophy-rise':''}`} style={{borderColor:trophy.color,color:trophy.color}} data-testid={`${prefix}-trophy`} data-tier={trophy.key} data-transition={celebrate?'true':'false'}>
    <Trophy aria-hidden="true" className="w-12 h-12 shrink-0" style={{fill:`${trophy.color}22`}}/>
    <div><p className="text-lg font-bold" data-testid={`${prefix}-tier`}>{trophy.label}</p><p className="text-2xl font-bold" data-testid={`${prefix}-standard-score`}>{score==null?'—':`${Number(score).toFixed(2)}%`}</p></div>
    <div className="ml-auto text-sm flex items-center gap-2" data-testid={`${prefix}-trophy-streak`}><Flame className="w-4"/>{trophy.streak} streak</div>
    {celebrate&&<p className="w-full text-xs" data-testid={`${prefix}-tier-change`}>Trophy status updated · {trophy.label}</p>}
  </div>;
};